<template>
  <div v-if="linkContent" class="zurich-card-alt bg-highlighted">
    <ZtLink :to="linkContent">
      <div class="zurich-card-alt-image">
        <ZurichCardBrochure />
      </div>
      <h2 class="title is-h5">{{ props.benefit }}</h2>
      <ul class="zurich-card-features font-bold is-size-6">
        <li v-for="(feature, i) in features" :key="i">{{ feature }}</li>
      </ul>
      <div class="button is-fullwidth">
        <span>{{ $texts('buyAZurichCard') }}</span>
        <SpriteSymbol name="chevron-right" />
      </div>
    </ZtLink>
  </div>
</template>

<script lang="ts" setup>
const { $texts } = useEasyTexts()

const props = withDefaults(
  defineProps<{
    benefit?: string
  }>(),
  {
    benefit: '',
  },
)

const data = useInitData()

const linkContent = computed(() => data.value.pages.zurichCardInfo)

const features = computed(() => [
  $texts('zurichCardFeature1'),
  $texts('zurichCardFeature2'),
  $texts('zurichCardFeature3'),
  $texts('zurichCardFeature4'),
])
</script>

<style lang="postcss">
.zurich-card-alt {
  @apply relative overflow-hidden border border-solid border-border px-[1rem] pb-[4rem] pt-[1rem];
  .feature {
    @apply text-scheme-light;
  }
  &:hover {
    @apply border-muted;
    .zurich-card-alt-image {
      transform: translateX(-0.75rem) rotate(3deg);
    }
  }
  > a {
    @apply block;
  }
  .button {
    @apply absolute bottom-0 left-0 z-[5] mt-[24px] w-full justify-start border-0 bg-scheme-light text-left text-background;
  }
}
.zurich-card-alt-image {
  @apply belowTablet:mt-[-8rem];
  @apply pointer-events-none float-right mb-0 ml-[1rem] mr-[-2.5rem] w-[7rem] select-none border border-solid border-border;
  @apply tablet:w-[6rem];
  @apply desktop:mb-[1rem] desktop:ml-[1.5rem] desktop:mt-[-5rem] desktop:w-[7.5rem];
  background-color: rgb(var(--color-white));
  box-shadow: 1px 3px 7px 0px rgb(var(--color-border));
  @media (prefers-color-scheme: dark) {
    box-shadow: 1px 3px 7px 0px black;
  }
  transform: rotate(8deg);
  transition: 0.4s;
  @media (prefers-color-scheme: dark) {
    background-color: rgb(var(--color-black));
  }
}
.zurich-card-features {
  @apply leading-[1.2] text-muted;
  > li {
    &:not(:last-child) {
      @apply mb-[0.75em];
    }
  }
}
</style>
